export default function AvisGoogle() {
  const avis = [
    {
      texte: "Volet bloqué depuis 3 jours, le technicien est arrivé en 45 minutes et a tout réparé sur place. Prix très correct, je recommande vivement.",
      prenom: "Marie",
      ville: "Strasbourg",
      service: "Dépannage urgent",
      date: "il y a 2 semaines",
    },
    {
      texte: "Remplacement du moteur Somfy sur mes 3 volets. Travail propre, rapide et bien expliqué. La télécommande était déjà programmée à leur départ.",
      prenom: "Pierre",
      ville: "Schiltigheim",
      service: "Remplacement moteur",
      date: "il y a 1 mois",
    },
    {
      texte: "Sangle de volet cassée depuis des mois. J'ai enfin trouvé un artisan qui avait la pièce en stock et qui est passé le jour même. Top service.",
      prenom: "Sophie",
      ville: "Haguenau",
      service: "Remplacement sangle",
      date: "il y a 3 semaines",
    },
    {
      texte: "Installation complète de 5 volets roulants neufs sur notre maison. Devis clair, délai respecté, et le résultat est impeccable. Merci à toute l'équipe.",
      prenom: "Lucas",
      ville: "Sélestat",
      service: "Pose volet roulant",
      date: "il y a 2 mois",
    },
    {
      texte: "Mon volet électrique ne répondait plus du tout. Diagnostic rapide, c'était la télécommande. Ils m'en ont reprogrammé une neuve en 20 minutes. Très efficace.",
      prenom: "Claire",
      ville: "Illkirch-Graffenstaden",
      service: "Réparation électrique",
      date: "il y a 1 semaine",
    },
    {
      texte: "Motorisation de mes 4 volets manuels avec moteur Nice. Le technicien m'a expliqué le fonctionnement en détail. Rien à redire, professionnalisme au rendez-vous.",
      prenom: "Thomas",
      ville: "Lingolsheim",
      service: "Motorisation",
      date: "il y a 1 mois",
    },
  ];

  const totalAvis = 42;
  const note = 5.0;

  const renderStars = () => (
    <div className="flex items-center gap-0.5">
      <i className="ri-star-fill text-yellow-500 text-sm"></i>
      <i className="ri-star-fill text-yellow-500 text-sm"></i>
      <i className="ri-star-fill text-yellow-500 text-sm"></i>
      <i className="ri-star-fill text-yellow-500 text-sm"></i>
      <i className="ri-star-fill text-yellow-500 text-sm"></i>
    </div>
  );

  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-[#1B2A4A] text-2xl md:text-3xl font-extrabold mb-3">
            Les avis de nos clients
          </h2>
          <p className="text-[#2F4A63] text-base md:text-lg max-w-2xl mx-auto">
            Des témoignages authentiques de nos clients à Strasbourg et dans le Bas-Rhin.
          </p>
        </div>

        <div className="bg-white rounded-2xl border border-[#E2E8F0] p-6 md:p-8 mb-10 md:mb-14">
          <div className="flex flex-col sm:flex-row items-center gap-6 sm:gap-10">
            <div className="text-center sm:text-left">
              <div className="text-[#1B2A4A] text-5xl md:text-6xl font-extrabold leading-none">
                {note.toFixed(1)}
              </div>
              <div className="flex items-center justify-center sm:justify-start gap-1 mt-2">
                <i className="ri-star-fill text-yellow-500 text-lg"></i>
                <i className="ri-star-fill text-yellow-500 text-lg"></i>
                <i className="ri-star-fill text-yellow-500 text-lg"></i>
                <i className="ri-star-fill text-yellow-500 text-lg"></i>
                <i className="ri-star-fill text-yellow-500 text-lg"></i>
              </div>
              <p className="text-[#2F4A63]/60 text-sm mt-1">
                {totalAvis} avis Google
              </p>
            </div>

            <div className="flex-1 w-full sm:max-w-md">
              {[5, 4, 3, 2, 1].map((etoile) => (
                <div key={etoile} className="flex items-center gap-3">
                  <span className="text-[#2F4A63] text-sm w-3">{etoile}</span>
                  <i className="ri-star-fill text-[#E2E8F0] text-sm"></i>
                  <div className="flex-1 h-2.5 bg-[#F5F2EB] rounded-full overflow-hidden">
                    <div
                      className="h-full bg-[#E8734A] rounded-full"
                      style={{
                        width: etoile === 5 ? "92%" : etoile === 4 ? "6%" : etoile === 3 ? "2%" : "0%",
                      }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {avis.map((a, i) => (
            <div
              key={i}
              className="bg-[#F5F2EB] rounded-xl border border-[#E2E8F0] p-5 md:p-6 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#E8734A] text-white font-bold text-sm shrink-0">
                  {a.prenom[0]}
                </div>
                <div>
                  <p className="text-[#1B2A4A] font-semibold text-sm">{a.prenom}</p>
                  <p className="text-[#2F4A63]/60 text-xs">{a.date}</p>
                </div>
              </div>
              {renderStars()}
              <div className="mt-3 mb-4">
                <p className="text-[#2F4A63] text-sm leading-relaxed">{a.texte}</p>
              </div>
              <div className="mt-auto pt-3 border-t border-[#E2E8F0]">
                <p className="text-[#2F4A63]/60 text-xs">
                  {a.ville} — {a.service}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}